import {
  FETCH_COMPONENTS,
  SET_COMPONENTS,
  OPEN_REGISTER_COMPONENT_DIALOG,
  CLOSE_REGISTER_COMPONENT_DIALOG,
  CREATE_COMPONENT,
  UPDATE_COMPONENT,
  SET_SAVING_COMPONENT_FLAG_RESET,
  SET_SAVING_COMPONENT_FLAG_SUCCESS,
  SET_SAVE_COMPONENT_FAILED_RESET,
  SET_SAVE_COMPONENT_FAILED,
  DELETE_COMPONENT,
  SET_DELETE_COMPONENT_SUCCESS_RESET,
  SET_UPDATED_COMPONENT
} from "redux/constants/flowDesigner";

export const fetchComponents = (tenant_id) => ({
  type: FETCH_COMPONENTS,
  payload: { tenant_id }
});
export const setComponents = (payload) => ({
  type: SET_COMPONENTS,
  payload
});
export const openRegisterComponentDialog = () => ({
  type: OPEN_REGISTER_COMPONENT_DIALOG
});
export const closeRegisterComponentDialog = () => ({
  type: CLOSE_REGISTER_COMPONENT_DIALOG
});
export const createComponent = (configUpload, user, input, groupObj, callback) => ({
  type: CREATE_COMPONENT,
  payload: { configUpload, user, input, groupObj, callback }
});
export const updateComponent = (user, id, input, showToast = true) => ({
  type: UPDATE_COMPONENT,
  payload: { user, id, input, showToast }
});
export const setSavingComponentFlagReset = () => ({
  type: SET_SAVING_COMPONENT_FLAG_RESET
});
export const setSavingComponentFlagSuccess = () => ({
  type: SET_SAVING_COMPONENT_FLAG_SUCCESS
});
export const setSaveComponentFailedReset = () => ({
  type: SET_SAVE_COMPONENT_FAILED_RESET
});
export const setSaveComponentFailed = (errorMessage = null) => ({
  type: SET_SAVE_COMPONENT_FAILED,
  payload: errorMessage
});
export const deleteComponent = (tenant_id, component_id) => ({
  type: DELETE_COMPONENT,
  payload: { tenant_id, component_id }
});
export const setDeleteComponentSuccessReset = () => ({
  type: SET_DELETE_COMPONENT_SUCCESS_RESET
});
export const setUpdatedComponent = (payload) => ({
  type: SET_UPDATED_COMPONENT,
  payload
});
